<template>
  <div class="kpb-project-card" :class="`kpb-project-card--${theme}`">
    <template v-if="theme === 'masonry'">
      <span class="kpb-project-card__name">{{ item.name }}</span>
    </template>
    <template v-else-if="theme === 'tiles'">
      <span v-if="status" class="kpb-project-card__status">{{ status }}</span>
      <div class="kpb-project-card__content">
        <h3 class="kpb-project-card__name">{{ item.name }}</h3>

        <span v-if="$path('address.city', item)" class="kpb-project-card__address">
          {{ item.address.city }}
        </span>

        <span class="kpb-project-card__view-project">
          {{ $t('viewProject') }}
        </span>
      </div>
    </template>

    <template v-else>
      <span v-if="status" class="kpb-project-card__status">{{ status }}</span>
      <div class="kpb-project-card__content">
        <div class="kpb-project-card__title">
          <h3>{{ item.name }}</h3>
          <!-- arrow -->
          <svg
            v-if="!hideArrow"
            class="kpb-project-card__arrow"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"
            />
          </svg>
        </div>

        <div v-if="housingTypes" class="kpb-project-card__house-types">
          <!-- building -->
          <svg
            v-if="($path('metadata.residentialProperties.saleType', item) || []).includes('rent')"
            class="kpb-project-card__icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              d="M192 107v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12zm116-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm140 205v20H0v-20c0-6.627 5.373-12 12-12h20V24C32 10.745 42.745 0 56 0h336c13.255 0 24 10.745 24 24v456h20c6.627 0 12 5.373 12 12zm-64-12V32H64v448h128v-85c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v85h128z"
            />
          </svg>
          <!-- house -->
          <svg v-else class="kpb-project-card__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
            <path
              d="M570.53,242,512,190.75V48a16,16,0,0,0-16-16H400a16,16,0,0,0-16,16V78.75L298.53,4a16,16,0,0,0-21.06,0L5.47,242a16,16,0,0,0,21.07,24.09L64,233.27V464a48.05,48.05,0,0,0,48,48H464a48.05,48.05,0,0,0,48-48V233.27l37.46,32.79A16,16,0,0,0,570.53,242ZM480,464a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V205.27l192-168,192,168Zm0-301.25-64-56V64h64ZM208,218.67V325.34A26.75,26.75,0,0,0,234.66,352H341.3A26.76,26.76,0,0,0,368,325.34V218.67A26.75,26.75,0,0,0,341.3,192H234.66A26.74,26.74,0,0,0,208,218.67ZM240,224h96v96H240Z"
            />
          </svg>

          <span class="kpb-project-card__stats kpb-project-card__stats-property">{{ housingTypes }}</span>
        </div>
        <span v-if="$path('address.city', item)" class="kpb-project-card__address">
          <!-- map pin -->
          <svg class="kpb-project-card__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path
              d="M192 96c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0-256C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"
            />
          </svg>

          <span class="kpb-project-card__stats kpb-project-card__stats-city">{{ item.address.city }}</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    theme: {
      type: String,
      default: 'cards',
      enums: ['cards', 'masonry', 'tiles'],
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    status() {
      let saleTypes = this.$path('item.metadata.residentialProperties.saleType') || []
      if (saleTypes.includes('rent')) return this.$t(`residentialStatus:rent.${this.item.status}`)

      return this.$t(`residentialStatus:sale.${this.item.status}`)
    },
    housingTypes() {
      let types = this.item?.metadata?.residentialProperties
      if (!types?.propertyType) return
      return types.propertyType
        .map(type => {
          let propertyType = 'propertyType:' + type

          /*
          liten potensiel bug,
          hvis de har feks bolig til 200000kvm og kontor til 100000kvm
          så vises bolig til 200000kvm på kontor.
          */
          if (type === 'office') {
            if (Math.max(types.useableArea))
              return this.$tc(propertyType) + ' - ' + Math.max(types.useableArea) + ' kvm'
          }

          return this.$tc(propertyType)
        })
        .splice(0, 4)
        .join(' | ')
    },
  },
}
</script>

<style lang="scss">
.kpb-project-card {
  $breakAt: 850px;

  &--masonry {
    .kpb-project-card__name {
      font-size: 0.9em;
      position: absolute;
      bottom: 0.5rem;
      left: 0.5rem;
      padding: 0.5rem 0.8rem;
      background: rgba(black, 0.6);
      color: white;
      border-radius: 5px;
      transition: opacity 200ms ease-out;
      pointer-events: none;
    }
  }

  &--card {
    .kpb-project-card {
      &__status {
        $size: 96px;
        border-radius: 50%;
        position: absolute;
        width: $size;
        height: $size;
        right: 2.5rem;
        top: 1.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 0.8em;
        background: #ffffff;
        box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.06);
        @media (max-width: $breakAt) {
          right: 1rem;
          top: 1rem;
          font-size: 0.7em;
          width: calc(#{$size} - 15px);
          height: calc(#{$size} - 15px);
        }
      }
      &__title {
        display: flex;
        align-items: baseline;
        gap: 0.5rem;
        h3 {
          font-size: 1.4rem;
          margin: 0.3em 0;
        }
      }
      &__content {
        color: var(--primary);
        svg {
          height: 0.7em;
          margin-right: 0.3em;
        }
      }
      &__house-types {
      }
      &__address {
        text-transform: uppercase;
        font-size: 0.6em;
        svg {
          margin-right: 0.5em;
          margin-left: 0.1em;
          height: 1.2em;
        }
      }
    }
  }

  &--tiles {
    .kpb-project-card {
      &__status {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 11;
        color: white;
        background: var(--primary);
        font-size: 0.8em;
        text-align: center;
        padding: 0.75rem;
      }
      &__content {
        color: white;
        font-size: 1.5rem;

        position: absolute;
        inset: 0;
        z-index: 10;
        pointer-events: none;
        background: rgba(0, 0, 0, 0.4);
        transition: background 0.2s ease;
        display: grid;
        gap: 1rem;
        place-content: center;
        text-align: center;
      }
      &__name {
        margin: 0;
      }
      &__address {
        margin: 0;

        font-size: 0.7em;

        margin-bottom: 1rem;
      }
      &__view-project {
        margin: 0;
        font-size: 0.7em;
        text-decoration: underline;
        margin-top: auto;
        text-underline-offset: 0.3em;
        text-decoration-thickness: 1px;
      }
    }
  }
}
</style>
